import React, { Component } from 'react';
import styled from 'styled-components';
import styles from '../../../styles';
import { IconLink } from './';

const StyledContainer = styled.button`
  background: ${styles.color.CHARCOAL};
  border-radius: 0.75rem;
  box-sizing: border-box;
  padding: 0.5rem 1.5rem 0.5rem 0.5rem;
  border: 1px solid white;
  cursor: pointer;
  position: relative;
  overflow: hidden;
    align-items: center;
    display: flex;
  //line-height: 0;
  
  &:before {
    content: '';
    border-radius: inherit;
    background: ${styles.color.BLACK};
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transform-origin: 0 50%;
    transform: scale(0, 1) translate3d(0,0,0);
    transition-property: transform, opacity;
    transition-duration: 0.35s;
    transition-timing-function: ${styles.easing.outCubic};
  }
  
  .current-input-mouse &:hover,
  .current-input-touch &:active {
    &:before {
      opacity: 1;
      transform: scale(1, 1) translate3d(0,0,0);
    }
  }

  a {
    color: white !important;
  }
`;

class DownloadButton extends Component {
  state = {
    hover: false,
  };

  onMouseOver = () => {
    this.setState({
      hover: true,
    });
  };

  onMouseOut = () => {
    this.setState({
      hover: false,
    });
  };

  render() {
    return (
      <StyledContainer
        onMouseEnter={this.onMouseOver}
        onMouseLeave={this.onMouseOut}
        onTouchStart={this.onMouseOver}
        onTouchEnd={this.onMouseOut}
      >
        <IconLink isMouseOver={this.state.hover} {...this.props} />
      </StyledContainer>
    );
  }
}

export default DownloadButton;



// WEBPACK FOOTER //
// ./src/modules/pages/components/DownloadButton.js